import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import { TextField } from '@material-ui/core';
import { v4 as uuidv4 } from 'uuid';

export default function CommentDialog({title, description, id, initialValue, openDialog, onCancel, onOK, onTextFieldChanged, canSave}) {

    id = id || uuidv4();

    const handleTextChange = (e) => {
        onTextFieldChanged(e.target.value); 
    };

    const handleOK = (e) => {
        onOK(e);
    }

    const handleCancel = (e) => {
        onCancel(e);
    };

    return (
        <Dialog open={openDialog} aria-labelledby="form-dialog-title">
            <DialogTitle id={`form-dialog-title-${id}`}>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{description}</DialogContentText>
                <TextField
                    value={initialValue}
                    autoFocus
                    margin="dense"
                    id={`form-dialog-text-field-${id}`}
                    type="text"
                    variant="outlined"
                    fullWidth
                    onChange={handleTextChange} />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel} color="primary">Cancel</Button>
                <Button onClick={handleOK} color="primary" disabled={!canSave}>OK</Button>
            </DialogActions>
        </Dialog>
    );
 };